module.exports = require("promise/lib/rejection-tracking");


//////////////////
// WEBPACK FOOTER
// external "promise/lib/rejection-tracking"
// module id = 33
// module chunks = 0